import { useFeatureFlag } from '@artic/ui/feature-flags';
import { getQualityUrl } from '@artic/ui/lib/environment';
import { useTranslation } from 'react-i18next';

import type { LinkItemProps } from '~/layout/SidebarLayout';

/**
 * Settings → Columns, mirrored from Neo's `quality-sidebar.tsx`: Containers, Columns, Custom
 * Columns and (ENG-1035) Materials, all Neo pages, so all absolute hrefs.
 *
 * Materials is disabled rather than hidden while `bill_of_materials` is off, as in Neo. The
 * Settings group around it already hides without Settings read.
 */
export function useColumnsNavSubheader(): LinkItemProps {
  const { t } = useTranslation('translation');
  const billOfMaterials = useFeatureFlag('bill_of_materials');
  const quality = getQualityUrl();

  return {
    kind: 'subheader',
    name: t('nav.columns'),
    children: [
      { name: t('nav.containers'), href: `${quality}/products/containers` },
      { name: t('nav.columns'), href: `${quality}/columns/structured-configuration` },
      { name: t('nav.custom_columns'), href: `${quality}/columns/custom-configuration` },
      {
        name: t('nav.materials'),
        href: `${quality}/columns/materials`,
        disabled: !billOfMaterials,
      },
    ],
  };
}
